/**
 * ProgressBar component - Shows onboarding progress
 */

import {TOTAL_STEPS} from '@voxapilot/shared/types';
import {useOnboardingStore} from '@voxapilot/shared/stores';

export function ProgressBar() {
  const {currentStep, completedSteps} = useOnboardingStore();

  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-textSecondary">
          Step {currentStep} of {TOTAL_STEPS}
        </span>
        <span className="text-sm text-textTertiary">
          {Math.round(((completedSteps.length + (completedSteps.includes(currentStep) ? 0 : 1)) / TOTAL_STEPS) * 100)}% Complete
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className="bg-gray-900 h-2 rounded-full transition-all duration-300"
          style={{
            width: `${((completedSteps.length + (completedSteps.includes(currentStep) ? 0 : 1)) / TOTAL_STEPS) * 100}%`,
          }}
        />
      </div>
      <div className="flex justify-between mt-3">
        {Array.from({length: TOTAL_STEPS}).map((_, index) => {
          const step = index + 1;
          const isCompleted = completedSteps.includes(step);
          const isCurrent = currentStep === step;

          return (
            <div
              key={step}
              className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold transition-all ${
                isCompleted
                  ? 'bg-gray-900 text-white'
                  : isCurrent
                  ? 'bg-gray-900 text-white ring-2 ring-gray-300'
                  : 'bg-gray-200 text-gray-600'
              }`}
            >
              {isCompleted ? '✓' : step}
            </div>
          );
        })}
      </div>
    </div>
  );
}

